export class FetchUsersFailure {
    static readonly type = '[User] FetchUsersFailure';
}
